<template>
  <div>
    <div class="hm-headline">
      <span class="headline">积分商城</span>
      <span class="subhead">兑换优惠券管理-{{ subTitle }}</span>
    </div>
    <el-card>
      <el-form
        label-position="top"
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
      >
        <el-form-item label="选择优惠券：">
          <div class="hm-form-container">
            <div class="transfer-panel">
              <el-input
                size="small"
                clearable
                placeholder="优惠券名称"
                v-model.trim="name"
              ></el-input>
              <el-button
                size="small"
                type="primary"
                class="hmicon icon-search"
                style="margin-left: 0"
                @click="search"
                :disabled="brandId === '' && catId === '' && name === ''"
              ></el-button>
            </div>
            <div class="transfer">
              <div class="transfer-header text-center">
                <span class="leftName">可选优惠券</span>
              </div>
              <div class="transfer-body flex">
                <el-radio-group size="small" v-model="goodsOfflineList">
                  <div
                    v-for="(v, i) in sendCouponsList"
                    :key="i"
                    class="check-wrapper flex"
                  >
                    <div class="flex-2">
                      <el-radio :label="v.id">{{ v.name }}</el-radio>
                    </div>
                  </div>
                </el-radio-group>
              </div>
            </div>
          </div>
        </el-form-item>
        <div class="flex">
          <el-form-item label="库存：" prop="name">
            <el-input
              size="small"
              @mousewheel.prevent.native
              clearable
              v-model.trim="ruleForm.name"
              type="number"
            ></el-input>
          </el-form-item>
        </div>
        <div class="flex item-center">
          <el-form-item
            label="兑换积分："
            prop="name"
            style="margin-right: 2rem"
          >
            <el-input
              size="small"
              @mousewheel.prevent.native
              clearable
              v-model.trim="ruleForm.name"
              type="number"
            ></el-input>
            <span class="form-tip">(注:兑换积分需要填整数)</span>
          </el-form-item>
          <el-form-item label="兑换金额：" prop="name">
            <el-input
              size="small"
              @mousewheel.prevent.native
              clearable
              v-model.trim="ruleForm.name"
              type="number"
            ></el-input>
            <span class="form-tip">(注:兑换金额允许保留两位小数)</span>
          </el-form-item>
        </div>
        <el-form-item label="PLUS会员专享：">
          <div class="flex item-center">
            <el-checkbox v-model="checked">开启PLUS会员专享</el-checkbox>
            <span class="form-tip"
              >(注:勾选后将在PLUS兑换列表显示，且只限PLUS会员兑换)</span
            >
          </div>
        </el-form-item>
        <el-form-item label="兑换时间：">
          <el-date-picker
            size="small"
            v-model="value6"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
          <span class="form-tip"
            >(注:系统会在该时间时才会生效，不填写默认为永久有效)</span
          >
        </el-form-item>
        <el-form-item label="每账户限兑：" prop="name">
          <el-input
            size="small"
            @mousewheel.prevent.native
            clearable
            v-model.trim="ruleForm.name"
            type="number"
          ></el-input>
          <span class="form-tip"
            >(注:只允许填写整数，填写总数不得超过库存)</span
          >
        </el-form-item>
        <el-form-item label="兑换说明：">
          <el-input
            size="small"
            type="textarea"
            placeholder="请输入内容"
            v-model.trim="textarea2"
            style="width: 300px"
          ></el-input>
        </el-form-item>
        <el-form-item label="兑换状态：">
          <el-switch v-model="value4" 
            active-color="#13ce66"> </el-switch>
        </el-form-item>
        <div class="btn-wrapper text-center">
          <el-button
            size="small"
            type="primary"
            round
            @click="save"
            :loading="isSaving"
            >保存</el-button
          >
          <el-button size="small" round @click="back">返回</el-button>
        </div>
      </el-form>
    </el-card>
  </div>
</template>
<script>
// 暂时不保存运费券
export default {
  data() {
    return {
      value4: "",
      displayMode: this.$route.params.type,
      id: this.$route.params.id,
      subTitle: "",
      catId: "",
      brandId: "",
      name: "",
      ruleForm: {},
      goodsOfflineList: [],
      rules: {
        name: [
          { required: true, message: "请输入售价", trigger: "blur" },
          {
            min: 1,
            max: 15,
            message: "售价长度需要 1 到 15 个字符",
            trigger: "blur"
          }
        ]
      },
      sendWayTypeOption: [
        {
          value: 0,
          label: "自动发放"
        },
        {
          value: 1,
          label: "手动发放"
        },
        {
          value: 2,
          label: "自助领券"
        },
        {
          value: 3,
          label: "兑换码领取"
        }
      ]
    };
  },
  computed: {
    categoryList() {
      return this.$store.state.rules.categoryList;
    },
    brandList() {
      return this.$store.state.rules.brandList;
    },
    goodsList() {
      return this.$store.state.rules.goodsList;
    },
    sendCouponsList() {
      return this.$store.state.rules.sendCouponsList;
    }
  },
  methods: {
    search() {
      this.$store.dispatch("querySendCoupons", {
        status: this.status,
        sendWayType: this.sendWayType,
        type: this.sendTarget,
        event: this.event,
        name: this.name,
        pageNo: 1
      });
    },
    getOnlineBrand() {
      this.$store.dispatch("queryBrand");
    },
    getOnlineCategory() {
      this.$store.dispatch("queryCategory");
    },
    queryGoodsList() {
      this.$store.dispatch("queryGoodsList", {
        brandId: this.brandId,
        catId: this.catId,
        name: this.name
      });
    },
    back() {
      this.$router.back();
    }
  }
};
</script>
<style lang="scss" scoped>
.transfer {
  border: 1px solid #e7e8ec;
  height: 485px;
  width: 500px;
  border-radius: 5px;
}
.transfer-header {
  padding: 10px;
  background: #ecf2ff;
  border-radius: 5px 5px 0 0;
  height: 19px;
  line-height: 19px;
}
.transfer-body {
  padding: 10px;
  border-radius: 0 0 5px 5px;
  height: 403px;
  overflow-y: scroll;
}
.check-wrapper {
  line-height: 2rem;
}

.form-tip {
  font-size: 12px;
  color: #999;
  margin-left: 0.5rem;
}

.hm-form-container {
  margin: 0.5rem 0;
  padding: 10px;
  border: 1px solid #e7e8ec;
  border-radius: 5px;
}
</style>
